import { render, staticRenderFns } from "./bankSlipWriteOff.vue?vue&type=template&id=ddf579d0&scoped=true&"
import script from "./bankSlipWriteOff.vue?vue&type=script&lang=js&"
export * from "./bankSlipWriteOff.vue?vue&type=script&lang=js&"
import style0 from "./bankSlipWriteOff.vue?vue&type=style&index=0&id=ddf579d0&lang=scss&scoped=true&"
import style1 from "./bankSlipWriteOff.vue?vue&type=style&index=1&id=ddf579d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf579d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf579d0')) {
      api.createRecord('ddf579d0', component.options)
    } else {
      api.reload('ddf579d0', component.options)
    }
    module.hot.accept("./bankSlipWriteOff.vue?vue&type=template&id=ddf579d0&scoped=true&", function () {
      api.rerender('ddf579d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/bankSlip/bankSlipWriteOff.vue"
export default component.exports